import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ThreePhases() {
  const revealRef = useScrollReveal();
  const phases = [{
    num: '01',
    name: 'EL QUIEBRE',
    title: 'El llamado del alma',
    text: 'Localizas el imán electromagnético del trauma en tu cuerpo y comienzas a desactivarlo. Tu crisis no es un error — es la señal más precisa de tu alma.',
    accent: 'border-l-[#7B5CE8]'
  }, {
    num: '02',
    name: 'EL VACÍO',
    title: 'El útero cuántico',
    text: 'Habitas el Punto Cero donde todo vuelve a ser posibilidad pura. Dejas de observar el problema para que deje de existir.',
    accent: 'border-l-[#C9A96E]'
  }, {
    num: '03',
    name: 'EL SALTO',
    title: 'La autoridad cuántica',
    text: 'Con coherencia cerebro-corazón, colapsas una nueva línea de tiempo. No deseas — eliges. No atraes — ordenas al campo.',
    accent: 'border-l-[#FAF7F0]'
  }];
  return <section className="bg-brand-dark bg-grain py-[60px] md:py-[100px] px-[5%] relative overflow-hidden" data-id="element-222">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_rgba(123,92,232,0.08)_0%,_transparent_60%)] pointer-events-none z-0" data-id="element-223" />

      <div ref={revealRef} className="max-w-7xl mx-auto relative z-10 reveal" data-id="element-224">
        <div className="text-center mb-[56px]" data-id="element-225">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-226">
            EL PROTOCOLO
          </div>
          <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-cream leading-tight" data-id="element-227">
            Tu transformación en 3 fases irreversibles
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-228">
          {phases.map((phase, i) => <div key={i} className={`bg-white/[0.03] border border-brand-gold/15 border-l-[3px] ${phase.accent} rounded-[20px] p-[40px] transition-all duration-300 hover:-translate-y-[6px] hover:border-brand-gold/40 hover:shadow-[0_20px_48px_rgba(0,0,0,0.4)]`} data-id="element-229">
              <div className="font-display font-light text-[72px] text-brand-gold opacity-15 leading-none mb-2" data-id="element-230">
                {phase.num}
              </div>
              <div className="font-body text-[11px] tracking-[0.15em] uppercase text-brand-gold mb-3" data-id="element-231">
                Fase {phase.num} — {phase.name}
              </div>
              <h3 className="font-display italic text-[26px] text-brand-cream mb-4" data-id="element-232">
                {phase.title}
              </h3>
              <p className="font-body text-[14px] text-brand-cream/60 leading-[1.7]" data-id="element-233">
                {phase.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}